import { auditCollectorPiletModals } from '@sharefiledev/audit-collector-pilet-sdk';
import type { OverlayModalOptions } from '@sharefiledev/sharefile-appshell';
import { TranslatedString } from '../utils/TranslatedString';

export function getDefaultCreateActivityReportModalOptions(): Partial<
	OverlayModalOptions<typeof auditCollectorPiletModals.createActivityReportModal>
> {
	return {
		modalProps: {
			title: <TranslatedString localizationKey="create_activity_modal.title" />,
			centered: true,
			width: 600,
			styles: { body: { maxHeight: '100vh', overflowY: 'auto' } },
			footer: null,
		},
	};
}
